export default __webpack_public_path__ + "static/Pip-560ed10ed40c86d2191884e0f58ae8e2.jpg";